import { render, staticRenderFns } from "./FAMSIOTProcessView.vue?vue&type=template&id=47bb87b6"
import script from "./FAMSIOTProcessView.vue?vue&type=script&lang=js"
export * from "./FAMSIOTProcessView.vue?vue&type=script&lang=js"
import style0 from "./FAMSIOTProcessView.vue?vue&type=style&index=0&id=47bb87b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports